<p-dialog
   *ngIf="service.selectedDoctor()"
   header="Add doctor"
   [(visible)]="service.addDoctorDialogVisible"
   [modal]="true"
   [style]="{ width: '25rem' }"
   [draggable]="false"
   [resizable]="false">
   <div class="row g-3 mb-3 mt-0">
      <div class="col">
         <vc-radio-group
            label="Type"
            [(ngModel)]="service.selectedDoctor().type"
            [options]="doctorTypes"></vc-radio-group>
      </div>
   </div>
   <div
      class="row g-3 mt-4"
      *ngIf="service.selectedDoctor().type === VSPDoctor_Type.LendAHand">
      <div class="col">
         <label
            class="form-label vc-label mb-0"
            for="doctor">
            Search Doctor
         </label>
         <br />
         <p-autoComplete
            fluid
            id="doctor"
            appendTo="body"
            [(ngModel)]="selectedDoc"
            [suggestions]="dayforceResults"
            (completeMethod)="searchDayforceEmployees($event)"
            [forceSelection]="true"
            (onSelect)="onDayforceIdChange($event)"
            field="label"></p-autoComplete>
      </div>
   </div>
   <ng-container *ngIf="service.selectedDoctor().type === VSPDoctor_Type.Relief">
      <div class="row g-3 mt-4">
         <div class="col">
            <vc-radio-group
               label="Relief Type"
               [options]="reliefTypes"
               [(ngModel)]="reliefType"></vc-radio-group>
            <br />
            <vc-text-input
               *ngIf="reliefType() === true"
               required="true"
               label="Agency Name"
               [(ngModel)]="service.selectedDoctor().agencyName"></vc-text-input>
            <vc-text-input
               *ngIf="reliefType() != null"
               label="Doctor First Name"
               class="doctor-name"
               required="true"
               [(ngModel)]="service.selectedDoctor().firstName"></vc-text-input>
            <vc-text-input
               *ngIf="reliefType() != null"
               label="Doctor Last Name"
               class="doctor-name"
               required="true"
               [(ngModel)]="service.selectedDoctor().lastName"></vc-text-input>
         </div>
      </div>
   </ng-container>
      <small *ngIf="doctorExists()" style="color:#ed5a68;">This doctor is already added to this practice, try adding from the inactive doctors list.</small>
   <div
      class="row g-3 mt-2"
      *ngIf="service.selectedDoctor().type === VSPDoctor_Type.Relief"></div>
   <ng-template pTemplate="footer">
      <button
         (click)="cancel()"
         class="v-button v-button-md v-darkgreen-border m-1 mt-2">
         Cancel
      </button>
      <button
         (click)="save()"
         [disabled]="!isValid()"
         class="v-button v-button-md v-darkgreen m-1 mt-2">
         Save
      </button>
   </ng-template>
</p-dialog>
